class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );

    // EMPIRIC (2026-09-23): the notification sits inside the sticky header's
    // positioning context, so it rides along while the customer scrolls the
    // page instead of scrolling away with it. On mobile its content (product
    // row, rewards bar, three stacked links) is full width and tall enough
    // to cover most of the screen. Auto-closing it a few seconds after it
    // opens turns it back into a quick confirmation instead of a panel
    // someone has to dismiss by hand to keep browsing. Cancelled on 'click'
    // (not 'pointerdown') so only a real tap on something in the notification,
    // like "View cart" or "Check out," keeps it open. A finger landing on the
    // panel to start a scroll-down swipe never produces a 'click' event, so
    // that gesture is left alone and the auto-close still fires -- otherwise
    // the panel covers most of the screen, so nearly every scroll attempt
    // would start with a touch on it and cancel the close.
    this.autoCloseDelay = 5000;
    this.autoCloseTimeout = null;
    this.notification.addEventListener('click', this.cancelAutoClose.bind(this));
    this.notification.addEventListener('focusin', this.cancelAutoClose.bind(this));
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);

    this.cancelAutoClose();
    this.autoCloseTimeout = setTimeout(() => this.close(), this.autoCloseDelay);
  }

  close() {
    this.cancelAutoClose();
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  cancelAutoClose() {
    if (this.autoCloseTimeout) {
      clearTimeout(this.autoCloseTimeout);
      this.autoCloseTimeout = null;
    }
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
      {
        id: 'cart-notification-rewards',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
